import { render, staticRenderFns } from "./hint.vue?vue&type=template&id=2b118210&scoped=true&"
import script from "./hint.vue?vue&type=script&lang=js&"
export * from "./hint.vue?vue&type=script&lang=js&"
import style0 from "./hint.vue?vue&type=style&index=0&id=2b118210&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b118210",
  null
  
)

export default component.exports